import { render, staticRenderFns } from "./TextAreaInput.vue?vue&type=template&id=49c0713a&"
import script from "./TextAreaInput.vue?vue&type=script&lang=js&"
export * from "./TextAreaInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\takaj\\Documents\\COFOUNDRY\\okinus-ui\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('49c0713a')) {
      api.createRecord('49c0713a', component.options)
    } else {
      api.reload('49c0713a', component.options)
    }
    module.hot.accept("./TextAreaInput.vue?vue&type=template&id=49c0713a&", function () {
      api.rerender('49c0713a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "packages/fndry-vue/packages/fn-types/inputs/TextAreaInput.vue"
export default component.exports